import { render } from "./InvestmentsPage.vue?vue&type=template&id=452695e0&scoped=true"
import script from "./InvestmentsPage.vue?vue&type=script&lang=js"
export * from "./InvestmentsPage.vue?vue&type=script&lang=js"

import "./InvestmentsPage.vue?vue&type=style&index=0&id=452695e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452695e0"]])

export default __exports__